import RegistrarAccountActivationScreen from './RegistrarAccountActivationScreen';
export default RegistrarAccountActivationScreen;
